export default __webpack_public_path__ + "assets/models/d3a49c7cd362d3e0548ace7620c09960.glb";